import { render, staticRenderFns } from "./KioskAdditions.vue?vue&type=template&id=b4d0ceae&scoped=true&"
import script from "./KioskAdditions.vue?vue&type=script&lang=js&"
export * from "./KioskAdditions.vue?vue&type=script&lang=js&"
import style0 from "./KioskAdditions.vue?vue&type=style&index=0&id=b4d0ceae&scoped=true&lang=css&"
import style1 from "./KioskAdditions.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d0ceae",
  null
  
)

export default component.exports